module.exports = __webpack_public_path__ + "img/shizhong.a4fc0962.png";